import type { Locale } from "./locale.type";

/** The language's own name ("français", "العربية"…), from the platform, with a capital first letter. */
export function localeName(locale: Locale): string {
  const name = new Intl.DisplayNames([locale], { type: "language" }).of(locale) ?? locale;
  return name.charAt(0).toLocaleUpperCase(locale) + name.slice(1);
}
